export default "__VITE_ASSET__D3Fw96t9__"